import { useQuery } from '@apollo/client';
import { FileText, KeyRound, LinkIcon, Network, User, Users } from 'lucide-react';
import { use, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, Outlet, useLocation } from 'react-router';
import Title from '../elements/Title';
import LocaleContext from '../hooks/LocaleContext';
import { CONTRACT } from './queries';

const SettingsPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { userSettings } = use(LocaleContext);
  const { data: contract } = useQuery(CONTRACT);

  const [currentRoute, setCurrentRoute] = useState('/settings');

  useEffect(() => {
    setCurrentRoute(location.pathname);
  }, [location]);

  return (
    <div className="all-settings">
      <Title title={t('settings.pageTitle')} />
      <div className="list-menu py-4 flex">
        <div className="w-1/4 px-4">
          <NavLink
            className={({ isActive }) => `list-menu-item ${isActive || currentRoute === '/settings' ? 'active' : ''}`}
            end
            to="profile"
          >
            <div className="flex flex-row items-center">
              <User className="icons" size={20} />
              <span className="align-middle">{t('settings.nav.myProfile')}</span>
            </div>
          </NavLink>
          <NavLink className={({ isActive }) => `list-menu-item ${isActive ? 'active' : ''}`} end to="security">
            <div className="flex flex-row items-center">
              <KeyRound className="icons" size={20} />
              <span className="align-middle">{t('settings.nav.security')}</span>
            </div>
          </NavLink>
          {userSettings.company?.admin && (
            <NavLink className={({ isActive }) => `list-menu-item ${isActive ? 'active' : ''}`} end to="organization">
              <div className="flex flex-row items-center">
                <Network className="icons" size={20} />
                <span className="align-middle">{t('settings.nav.organization')}</span>
              </div>
            </NavLink>
          )}
          {userSettings.company?.admin && (
            <NavLink className={({ isActive }) => `list-menu-item ${isActive ? 'active' : ''}`} end to="accessgroups">
              <div className="flex flex-row items-center">
                <Users className="icons" size={20} />
                <span className="align-middle">{t('settings.nav.jobAccessGroups')}</span>
              </div>
            </NavLink>
          )}
          <NavLink className={({ isActive }) => `list-menu-item ${isActive ? 'active' : ''}`} end to="accessgroupsv2">
            <div className="flex flex-row items-center">
              <Users className="icons" size={20} />
              <span className="align-middle">{t('settings.nav.accessGroupsv2')}</span>
            </div>
          </NavLink>
          {userSettings.company?.admin && contract && (
            <NavLink className={({ isActive }) => `list-menu-item ${isActive ? 'active' : ''}`} end to="accountinfo">
              <div className="flex flex-row items-center">
                <FileText className="icons" size={20} />
                <span className="align-middle">{t('settings.nav.accountInformation')}</span>
              </div>
            </NavLink>
          )}
          <NavLink className={({ isActive }) => `list-menu-item ${isActive ? 'active' : ''}`} end to="integrations">
            <div className="flex flex-row items-center">
              <LinkIcon className="icons" size={20} />
              <span className="align-middle">{t('settings.nav.integrations')}</span>
            </div>
          </NavLink>
        </div>
        <div className="w-3/4">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
